<template>
  <el-col :span="8">
    <a :href="`product/` + productItem.product_id">
      <div class="product-item">
        <!--图片-->
        <div style="background: #fafafa; width: 340px; height: 240px; margin: 0 auto;">
          <img :src="productItem.image_paths[0]" alt="" style="width: inherit; height: inherit; object-fit: contain;">
        </div>
        <div style="width: 100%; text-align: center; margin-top: 20px">
          <!--标题-->
          <div style="font-size: 22px; line-height: 40px; color: #71777c;">{{ productItem.product_name }}</div>
          <a>查看更多</a>
        </div>
      </div>
    </a>
  </el-col>

</template>

<script>
export default {
  name: 'ProductItems',
  props: {
    productItem: {
      type: Object,
      require: true
    }
  }
}
</script>

<style scoped>
  .product-item {
    margin-bottom: 30px;
    width: 100%;
    height: 360px;
    box-shadow: 0 1px 10px rgba(21, 21, 41, .1);
    padding-top: 10px;
    transition: box-shadow 0.3s;
  }
  .product-item:hover {
    box-shadow: 3px 3px 20px rgba(21, 21, 41, .3);
  }
</style>
